<template>
    <div :class="{'time-line': true, 'time-line-r': timeLineItem.alignment == 1}">
        <div class="title" v-if="timeLineItem.display_title == 1">{{timeLineItem.title}}</div>
        <div class="summary" v-html="timeLineItem.summary" v-if="timeLineItem.summary"></div>

        <div class="line" v-if="line_content && line_content.length > 0">
            <div class="line-list line-year" v-if="line_type == 0">
                <span class="start-icon"></span>
                <div v-for="item1,index1 in year" :key="index1" class="line-li clear">
                    <div class="line-li-content">
                        <div class="line-time">{{item1}}年</div>
                        <div class="line-content">
                            <div v-for="item2,index2 in topic_line_year[item1]" :key="index2">
                                <div class="topic-title">{{item2.title}}</div>
                                <div class="topic-content" v-if="timeLineItem.display_topic_content == 1">{{item2.content_unsigned}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <span class="end-icon"></span>
            </div>

            <div class="line-list line-list-2" v-if="line_type == 1 && timeLineItem.alignment != 1">
                <span class="start-icon"></span>
                <div v-for="item1,index1 in year" :key="index1" class="line-li">
                    <div
                        v-for="item2,index2 in month"
                        :key="index2"
                        class="line-li-m clear"
                        v-if="moment(item2).format('YYYY') == item1"
                    >
                        <div class="line-li-content">
                            <div class="line-time">
                                <p class="p1">{{item1}}年</p>
                                <p class="p2">{{item2 | time_moment('M月')}}</p>
                            </div>
                            <div class="line-content">
                                <div v-for="item3,index3 in topic_line_month[item1][moment(item2).format('M')]" :key="index3">
                                    <div class="topic-title">{{item3.title}}</div>
                                    <div class="topic-content" v-if="timeLineItem.display_topic_content == 1">{{item3.content_unsigned}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span class="end-icon"></span>
            </div>

            <div class="line-list line-list-2" v-if="line_type > 1 && timeLineItem.alignment != 1">
                <span class="start-icon"></span>
                <div v-for="item1,index1 in year" :key="index1" class="line-li">
                    <div
                        v-for="item2,index2 in date"
                        :key="index2"
                        class="line-li-m clear"
                        v-if="moment(item2).format('YYYY') == item1"
                    >
                        <div class="line-li-content">
                            <div class="line-time">
                                <p class="p1">{{item1}}年</p>
                                <p class="p2">{{item2 | time_moment('MM-DD')}}</p>
                            </div>
                            <div class="line-content">
                                <div v-for="item3,index3 in topic_line_date[item1][moment(item2).format('MM-DD')]" :key="index3">
                                    <p
                                        class="topic-time"
                                        v-if="line_type == 3"
                                    >
                                        {{item3.oldest_news_publish_time | time_moment('HH:mm')}}
                                    </p>
                                    <div class="topic-title">{{item3.title}}</div>
                                    <div class="topic-content" v-if="timeLineItem.display_topic_content == 1">{{item3.content_unsigned}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <span class="end-icon"></span>
            </div>

            <div class="line-list line-year" v-if="line_type == 1 && timeLineItem.alignment == 1">
                <span class="start-icon"></span>
                <div v-for="item1,index1 in year" :key="index1" class="line-li clear">
                    <div class="line-li-content">
                        <div class="line-time">{{item1}}年</div>
                        <div class="line-content">
                            <div
                                v-for="item2,index2 in month"
                                :key="index2"
                                class="s-content"
                                v-if="moment(item2).format('YYYY') == item1"
                            >
                                <p class="s-time">{{item2 | time_moment('M月')}}</p>
                                <div v-for="item3,index3 in topic_line_month[item1][moment(item2).format('M')]" :key="index3">
                                    <div class="topic-title">{{item3.title}}</div>
                                    <div class="topic-content" v-if="timeLineItem.display_topic_content == 1">{{item3.content_unsigned}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span class="end-icon"></span>
            </div>

            <div class="line-list line-year" v-if="line_type == 2 && timeLineItem.alignment == 1">
                <span class="start-icon"></span>
                <div v-for="item1,index1 in year" :key="index1" class="line-li clear">
                    <div class="line-li-content">
                        <div class="line-time">{{item1}}年</div>
                        <div class="line-content">
                            <div
                                v-for="item2,index2 of date"
                                :key="index2"
                                class="s-content"
                                v-if="moment(item2).format('YYYY') == item1"
                            >
                                <p class="s-time">{{item2 | time_moment('MM-DD')}}</p>
                                <div v-for="item3,index3 in topic_line_date[item1][moment(item2).format('MM-DD')]" :key="index3">
                                    <div class="topic-title">{{item3.title}}</div>
                                    <div class="topic-content" v-if="timeLineItem.display_topic_content == 1">{{item3.content_unsigned}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span class="end-icon"></span>
            </div>

            <div class="line-list line-list-2" v-if="line_type == 3 && timeLineItem.alignment == 1">
                <span class="start-icon"></span>
                <div v-for="item1,index1 in year" :key="index1" class="line-li">
                    <div
                        v-for="item2,index2 of date"
                        :key="index2"
                        class="line-li-m clear"
                        v-if="moment(item2).format('YYYY') == item1"
                    >
                        <div class="line-li-content">
                            <div class="line-time">
                                <p class="p1">{{item1}}年</p>
                                <p class="p2">{{item2 | time_moment('MM-DD')}}</p>
                            </div>
                            <div class="line-content">
                                <div v-for="item3,index3 in topic_line_date[item1][moment(item2).format('MM-DD')]" :key="index3">
                                    <p class="topic-time">{{item3.oldest_news_publish_time | time_moment('HH:mm')}}</p>
                                    <div class="topic-title">{{item3.title}}</div>
                                    <div class="topic-content" v-if="timeLineItem.display_topic_content == 1">{{item3.content_unsigned}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <span class="end-icon"></span>
            </div>
        </div>

        <div class="spa">
            <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="handleShare(paramsUid, timeLineItem.id)" @on-popper-hide="handleShareHide">
                <i class="iconfont">&#xe641;</i>
                <div slot="content" class="share_cnt clear">
                    <div class="share_img"></div>
                    <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                </div>
            </Poptip>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
export default {
  props: ['timeLineItem', 'moduleId', 'paramsUid'],
  data() {
    return {
      topic_line: {},
      year: [],
      month: [],
      date: [],
      topic_line_year: {},
      topic_line_month: {},
      topic_line_date: {},
      moment: moment
    }
  },
  computed: {
    line_content() {
      return this.timeLineItem.line_content
    },
    line_type() {
      return this.timeLineItem.time_format
    }
  },
  methods: {
    throughData() {
      this.line_content.map((a) => {
        let y = moment(a.oldest_news_publish_time).format('YYYY'),
            m = moment(a.oldest_news_publish_time).format('YYYY-MM'),
            d = moment(a.oldest_news_publish_time).format('YYYY-MM-DD')
        let yIndex = this.year.findIndex((b) => b == y),
            mIndex = this.month.findIndex((b) => b == m),
            dIndex = this.date.findIndex((b) => b == d)
        if (yIndex == -1) this.year.push(y)
        if (mIndex == -1) this.month.push(m)
        if (dIndex == -1) this.date.push(d)
      })
      this.year.map((a) => {
        this.topic_line_year[a] = []
        this.topic_line_month[a] = {}
        this.topic_line_date[a] = {}
      })
      this.month.map((a) => {
        let y = moment(a).format('YYYY'),
            m = moment(a).format('M')
        this.topic_line_month[y][m] = []
      })
      this.date.map((a) => {
        let y = moment(a).format('YYYY'),
            m = moment(a).format('M'),
            d = moment(a).format('MM-DD')
        this.topic_line_date[y][d] = []
      })
      this.line_content.map((a) => {
        let y = moment(a.oldest_news_publish_time).format('YYYY'),
            m = moment(a.oldest_news_publish_time).format('M'),
            d = moment(a.oldest_news_publish_time).format('MM-DD')
        this.topic_line_year[y].push(a)
        this.topic_line_month[y][m].push(a)
        this.topic_line_date[y][d].push(a)
      })
      // console.log(this.year, this.topic_line_month)
      this.$forceUpdate()
    },
    lineLiFloat() {
      $('.line-list-2').each(function(index, el) {
        $(this).find('.line-li-m').each(function(index2, el2) {
          if(index2 % 2) {
            $(this).addClass('line-right')
          }else {
            $(this).addClass('line-left')
          }
        })
      })
    },
    handleShare(theme_uid, time_line_id) {
      let share_link = window.location.protocol + '//' + window.location.host + '/mindex/shareTimeLine?theme_uid=' + theme_uid + '&time_line_id=' + time_line_id
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
    },
    handleShareHide() {
      $('.share_img').html('')
    }
  },
  created() {
    // console.log(this.timeLineItem)
    this.throughData()
  },
  mounted() {
    this.lineLiFloat()
  },
  watch: {
    line_content() {
      this.lineLiFloat()
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
commonBorderRightColor1(color_d, color_l) // 背景
  [data-theme='dark'] & {
    border-right-color: color_d !important
  }
  [data-theme='light'] & {
    border-right-color: color_l !important
  }
.time-line
  commonColor(#fff, #333333)
  position: relative
  .title
    font-size: 16px
    font-weight: bold
    margin-bottom: 10px
    line-height: 22px
  .summary
    font-size: 14px
    commonColor(#BCBDC1, #666666)
    line-height: 22px
  .line
    margin-top: 10px
    .line-list
      position: relative
      padding: 24px 0
      &:before
        position: absolute
        content: ''
        top: 0
        bottom: 0
        left: 50%
        border-right: 1px dashed #FC9C7C
        z-index: 0
      .start-icon
      .end-icon
        position: absolute
        width: 15px
        height: 15px
        background-image: url('~pic/time_line_icon.png')
        background-size: 100%
        background-repeat: no-repeat
        left: 50%
        margin-left: -7px
      .start-icon
        top: 0
      .end-icon
        bottom: -1px
    .line-li
      position: relative
      .line-li-m + .line-li-m
        .line-time
          .p1
            display: none
      .year-tip
        position: absolute
        width: 42px
        height: 42px
        line-height: 42px
        background-image: url('~pic/time_line_icon.png')
        background-size: 100%
        background-repeat: no-repeat
        text-align: center
        font-size: 12px
        left: 50%
        margin-left: -21px
        top: -1px
      .line-li-content
        width: 308px
        position: relative
        .line-time
          position: absolute
          width: 84px
          top: 50%
          text-align: center
          commonBgColor(#1F2330, #FFFFFF)
          padding: 4px 0
          font-size: 16px
          color: #FC9C7C
          font-weight: 600
          translateY50()
          .p1
            margin-bottom: 2px
          .p2
            font-weight: normal
            commonColor(#797B83, #999999)
            font-size: 12px
        .line-content
          padding: 16px
          position: relative
          border-top: 1px solid transparent
          border-bottom: 1px solid transparent
          > div
            &+div
              margin-top: 16px
            &:first-of-type:before
            &:last-of-type:after
              content: ''
              position: absolute
              width: 308px
              height: 1px
              background-color: #2C8ACF
              left: -1px
            &:first-of-type:before
              top: -1px
            &:last-of-type:after
              bottom: -1px
          .topic-time
            color: #FC9C7C
            font-size: 12px
            margin-bottom: 5px
          .topic-title
          .topic-content
            font-size: 14px
            line-height: 22px
            commonColor(#E9E9EB, #333333)
            font-weight: bold
            margin: -4px 0
          .topic-content
            font-weight: normal
            commonColor(#BCBDC1, #666666)
            margin: 6px 0 -4px
          &:before
          &:after
            content: ''
            position: absolute
            width: 6px
            height: 13px
            right: -6px
            top: 50%
            margin-top: -7px
          &:before
            commonBgImg('~pic/time_line1.png', '~pic/time_line1.png')
            background-size: 100%
            background-repeat: no-repeat
            z-index: 2
          &:after
            commonBgColor(#1F2330, #FFFFFF)
            width: 10px
    .line-year .line-li:nth-of-type(odd)
    .line-list-2 .line-li-m.line-left
      .line-li-content
        float: left
        .line-time
          right: -84px
        .line-content
          border-left: 1px solid
          border-right: 1px solid
          commonBorderLeftColor(#40444F, #FFD9B9)
          commonBorderRightColor(#FC9C7C, #FC9C7C)
          > div
            &:first-of-type:before
            &:last-of-type:after
              commonBgColor(linear-gradient(to left, #FC9C7C 0%, #40444F 100%), linear-gradient(to left, #FC9C7C 0%, #FFD9B9 100%))
    .line-year .line-li:nth-of-type(even)
    .line-list-2 .line-li-m.line-right
      .line-li-content
        float: right
        .line-time
          left: -84px
        .line-content
          border-left: 1px solid #FC9C7C
          border-right: 1px solid #40444F
          commonBorderLeftColor(#FC9C7C, #FC9C7C)
          commonBorderRightColor(#40444F, #FFD9B9)
          &:before
          &:after
            left: -6px
            transform: rotate(180deg)
          > div
            &:first-of-type:before
            &:last-of-type:after
              commonBgColor(linear-gradient(to right, #FC9C7C 0%, #40444F 100%), linear-gradient(to right, #FC9C7C 0%, #FFD9B9 100%))
.time-line-r
  .line
    .line-list
      padding-top: 16px
      &:before
        left: 20px
      .start-icon
      .end-icon
        left: 20px
      .start-icon
        width: 17px
        height: 17px
        margin-left: -8px
        margin-top: -2px
        background-image: url('~pic/timeline.png')
    .line-li
      padding-top: 10px
      .line-li-m + .line-li-m
        padding-top: 10px
      .line-li-content
        width: 644px
        .line-time
          font-size: 12px
          font-weight: 600
          width: 62px
          left: -66px !important
        .s-content
          .s-time
            color: #FC9C7C
            font-size: 12px
            font-weight: 400
            margin-bottom: 5px
          div+div
            margin-top: 16px
        .line-content
          .topic-time
            color: #FC9C7C
    .line-year .line-li:nth-of-type(even)
    .line-list-2 .line-li-m.line-right
    .line-year .line-li:nth-of-type(odd)
    .line-list-2 .line-li-m.line-left
      .line-li-content
        float: right
        .line-content
          border-left: 1px solid
          border-right: 1px solid
          commonBorderLeftColor(#FC9C7C, #FC9C7C)
          commonBorderRightColor1(#40444F, #FFD9B9)
          &:before
          &:after
            left: -6px
            transform: rotate(180deg)
          > div
            &:first-of-type:before
            &:last-of-type:after
              width: 644px
              commonBgColor(linear-gradient(to right, #FC9C7C 0%, #40444F 100%), linear-gradient(to right, #FC9C7C 0%, #FFD9B9 100%))
.spa
  position: absolute
  right: 0
  bottom: 0
  width: 18px
  height: 18px
  .iconfont
    font-size: 18px
    line-height: 1
    position: absolute
    right: 0
    top: 0
    commonColor(#CCCCCC, #CCCCCC)
    &:hover
      color: #63bf61 !important
  & >>> .ivu-poptip
    position: absolute
    width: 18px
    height: 18px
    .ivu-poptip-rel
      position: absolute
      width: 18px
      height: 18px
      right: 0
      top: 0
      cursor: pointer
    .ivu-poptip-popper
      transform: translate(13px, 0)
      .ivu-poptip-inner
        border-radius: 0
        .share_cnt
          padding: 10px 20px 10px 10px
          .share_img
            width: 80px
            height: 80px
            float: left
            background: #f0f0f0
          p
            line-height: 20px
            color: #666
            float: right
            margin-top: 20px
            font-size: 14px
</style>
